import { Button, ButtonProps } from '@mui/material';
import React, { useContext } from 'react';

import { WebFormContext } from 'contexts/WebFormContext';

type FormButtonProps = ButtonProps & {
  children: React.ReactNode;
};

export function FormButton({ children, ...props }: FormButtonProps) {
  const { form } = useContext(WebFormContext);

  return (
    <Button {...props} disabled={form.isFilled || props.disabled}>
      {children}
    </Button>
  );
}
